import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as microsoftTeams from '@microsoft/teams-js';
import './index.css';
import App from './App';

// Initialize Microsoft Teams SDK if running inside Teams (iframe)
const isInTeams = window.parent !== window || window.name === 'embedded-page-container';
if (isInTeams) {
  microsoftTeams.app.initialize().then(() => {
    console.log('Teams SDK initialized successfully');
  }).catch((err) => {
    console.log('Not running in Teams context or initialization failed:', err);
  });
}

// Export Teams SDK for use in other components
export { microsoftTeams, isInTeams };

// Render the root component into the DOM
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
